export default {
  api: {
    baseUrl: 'https://api.x.wappin.app',
    chatUrl: 'https://api.chat.wappin.app',
    backOfficeUrl: 'https://api.x.wappin.app',
    leadsUrl: 'https://api.x.wappin.app/leads',
  },
};
